import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=68cdd1eb&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68cdd1eb')) {
      api.createRecord('68cdd1eb', component.options)
    } else {
      api.reload('68cdd1eb', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=68cdd1eb&", function () {
      api.rerender('68cdd1eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26NSAI47OscGW/JS/comp/FavElement.vue"
export default component.exports